/**
 * Marker colours for property maps, shared by the interactive map, its legend,
 * the printable sheet and the public client share page. A leaf module (no
 * imports) so the unauthenticated share page can use it without pulling in the
 * signed-in map/API code.
 */
export type DeviceType = 'controller' | 'water_meter' | 'double_check' | 'zone';

export const DEVICE_COLORS: Record<DeviceType, string> = {
  controller: '#2563eb',
  water_meter: '#16a34a',
  double_check: '#d97706',
  zone: '#0891b2',
};

export const PROPERTY_MARKER_COLOR = '#dc2626';
